import { render, staticRenderFns } from "./SubAccountSet.vue?vue&type=template&id=6410248a&scoped=true"
import script from "./SubAccountSet.vue?vue&type=script&lang=ts"
export * from "./SubAccountSet.vue?vue&type=script&lang=ts"
import style0 from "./SubAccountSet.vue?vue&type=style&index=0&id=6410248a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6410248a",
  null
  
)

export default component.exports